export default __webpack_public_path__ + "static/media/devil dress.57e816dc.wav";